module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [(_vm.description !== 'group') ? _c('h4', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), (_vm.showFilterBarFlag) ? _c('div', {
    staticClass: "nav-div"
  }, [_c('nav', {
    staticClass: "bar bar-nav merbar"
  }, [_c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("为您找到"), _c('span', {
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_vm._v(_vm._s(_vm.queryTotal.total))]), _vm._v("条结果")]), _vm._v(" "), (!_vm.showFilterBarForKit) ? _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#0a8ddf"
    }
  }, [_c('a', {
    staticClass: "pull-right open-panel",
    on: {
      "click": function($event) {
        return _vm.openshaxuan()
      }
    }
  }, [_vm._v("筛选")])]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (this.$route.query.id === 5 || this.$route.query.id === 8 || this.$route.query.id === 7 || this.$route.query.id === 9 || this.$route.name === 'searchresults') ? _c('div', {
    staticStyle: {
      "height": "2.2rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.merchs), function(pro, index) {
    return _c('div', {
      staticClass: "merchsdiv"
    }, [(_vm.description === 'group') ? _c('div', [_c('div', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "merchsdiv1",
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                ¥" + _vm._s(pro.priceMax) + "\n                "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]) : _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                ¥" + _vm._s(pro.priceMin) + "\n                "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "merchstitle"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name))])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type !== 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name))])]) : _vm._e(), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return (pro._subTitleList && pro._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1px"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((pro._abstractList), function(abstract) {
      return (pro._abstractList && pro._abstractList.length > 0) ? _c('span', {
        staticClass: "merchstitle2",
        staticStyle: {
          "padding-left": "3px"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((pro._titleList), function(title) {
      return (pro._titleList && pro._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "0.9rem",
          "color": "#3F3F3F",
          "padding-left": "0.1rem",
          "font-weight": "bold"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v("\n                      " + _vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, _vm._l((pro._specificatList), function(specificat) {
      return (pro._specificatList && pro._specificatList.length > 0) ? _c('span', {
        staticStyle: {
          "margin-left": "3px",
          "font-size": "small",
          "color": "#4479B4"
        }
      }, [_vm._v(_vm._s(specificat.label) + ": " + _vm._s(specificat.valueText))]) : _vm._e()
    }), 0), _vm._v(" "), (pro.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#003d8e"
      }
    }, [_vm._v("【第三方】")])]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 1) ? _c('hr') : _c('hr', {
      staticStyle: {
        "margin-top": "1px"
      }
    })], 2)])]) : _c('div', [(!pro.composite) ? _c('div', [_c('div', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "merchsdiv1",
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                  ¥" + _vm._s(pro.priceMax) + "\n                  "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]) : _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                  ¥" + _vm._s(pro.priceMin) + "\n                  "), (pro.cataloguePrice) ? _c('del', {
      staticStyle: {
        "color": "grey",
        "font-size": "0.7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.cataloguePrice))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "merchstitle"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name))])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].type !== 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name))])]) : _vm._e(), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return (pro._subTitleList && pro._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1px"
        }
      }), _vm._v(" "), (subTitle.valueText.length > 15) ? _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText.substring(0, 15)) + "...")]) : _vm._e(), _vm._v(" "), (subTitle.valueText.length <= 15) ? _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._l((pro._abstractList), function(abstract) {
      return (pro._abstractList && pro._abstractList.length > 0) ? _c('span', {
        staticClass: "merchstitle2",
        staticStyle: {
          "padding-left": "3px"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((pro._titleList), function(title) {
      return (pro._titleList && pro._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "0.9rem",
          "color": "#3F3F3F",
          "padding-left": "0.1rem",
          "font-weight": "bold"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v("\n                      " + _vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), _vm._v(" "), (pro.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small",
        "color": "#003d8e"
      }
    }, [_vm._v("【第三方】")])]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 1) ? _c('hr') : _c('hr', {
      staticStyle: {
        "margin-top": "1px"
      }
    })], 2)])]) : _vm._e(), _vm._v(" "), (pro.composite) ? _c('div', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.setdatas(pro)
        }
      }
    }, [_c('div', [_c('div', {
      staticClass: "merchsdiv1",
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [(pro.priceMin !== pro.priceMax) ? _c('div', {
      staticClass: "merchsprice"
    }, [_vm._v("\n                  ¥" + _vm._s(pro.priceMin) + " ~ ¥" + _vm._s(pro.priceMax) + "\n                ")]) : _c('div', {
      staticClass: "merchsprice"
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', [_vm._v("\n                      ¥" + _vm._s(pro.priceMax) + "\n                  ")]) : _c('span', [_vm._v("\n                      ¥" + _vm._s(pro.priceMin) + "\n                  ")])]), _vm._v(" "), _c('span', {
      staticClass: "merchstitle"
    }, [(pro.bpromotions && pro.bpromotions.length > 0 && pro.bpromotions[0].requiredCustomers === 0 && pro.bpromotions[0].type !== 0 && pro.bpromotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.bpromotions[0].name))])]) : _vm._e(), _vm._v(" "), (pro.promotions && pro.promotions.length > 0 && pro.promotions[0].requiredCustomers === 0 && pro.promotions[0].type !== 0 && pro.promotions[0].description !== '') ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(pro.promotions[0].name))])]) : _vm._e(), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return (pro._subTitleList && pro._subTitleList.length > 0) ? _c('span', [_c('span', {
        staticStyle: {
          "position": "relative",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1px"
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "0.5rem",
          "color": "white",
          "background-color": "#00469A",
          "padding": "0.1rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((pro._abstractList), function(abstract) {
      return (pro._abstractList && pro._abstractList.length > 0) ? _c('span', {
        staticClass: "merchstitle2",
        staticStyle: {
          "padding-left": "3px"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((pro._titleList), function(title) {
      return (pro._titleList && pro._titleList.length > 0) ? _c('span', {
        staticStyle: {
          "left": "0",
          "bottom": "0",
          "font-size": "0.9rem",
          "color": "#3F3F3F",
          "padding-left": "0.1rem",
          "font-weight": "bold"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])]) : _vm._e()
    }), _vm._v(" "), (pro.selfOperated === 0) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "x-small"
      }
    }, [_vm._v("【第三方】")])]) : _vm._e(), _vm._v(" "), (pro.selfOperated === 1) ? _c('hr') : _c('hr', {
      staticStyle: {
        "margin-top": "1px"
      }
    })], 2)])]) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23954744","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MerchandiseList.vue
// module id = 1569
// module chunks = 8